module.exports = __webpack_public_path__ + "static/media/capitalsphere_challenge.86458494.png";